import React from 'react'
import { IonRow, IonCol, IonLabel, IonText, IonIcon, IonItem } from '@ionic/react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { closeOutline } from 'ionicons/icons'
import AddEmail from '../../../components/addEmail/AddEmail.component'
import BoxComponent from '../../../components/box/Box.component'
import { getSpecialReportsSelector } from '../selectors'
import { setExtraEmail, saveSpecialReport } from '../store/specialReports.actions'

const AutoEmail: React.FC = () => {
  const { t } = useTranslation()
  const specialReportsData = useSelector(getSpecialReportsSelector)
  const { autoEmail } = specialReportsData
  return (
    <IonRow className='m-5 mt-10'>
      <IonCol size='12'>
        <IonLabel>
          <IonText className='header-title'>{t('specialReports.autoEmails')}</IonText>
        </IonLabel>
        <IonLabel className='auto-emails-label'>{t('specialReports.autoEmailsDescription')}</IonLabel>
      </IonCol>

      <IonCol size='12'>
        <BoxComponent
          id='auto-emails-box'
          dataTestId='auto-emails-box'
          className='auto-emails-box'
          fill='none'
          height='100px'
          width='100%'>
          <div className='auto-emails-container'>
            {autoEmail.map((email, index) => (
              <IonLabel key={`auto-email-${index}`} color='medium' className='auto-emails-text'>
                {email}
                {index < autoEmail.length - 1 && ', '}
              </IonLabel>
            ))}
          </div>
        </BoxComponent>
      </IonCol>
    </IonRow>
  )
}

const AdditionalEmail: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const specialReportsState = useSelector(getSpecialReportsSelector)
  const { extraEmail } = specialReportsState

  const handleSaveEmail = (email: string) => {
    const updatedExtraEmail = [...extraEmail, email]
    dispatch(setExtraEmail(updatedExtraEmail))
    dispatch(saveSpecialReport())
  }

  const handleRemoveEmail = (emailToRemove: string) => {
    const updatedExtraEmail = extraEmail.filter((email) => email !== emailToRemove)
    dispatch(setExtraEmail(updatedExtraEmail))
    dispatch(saveSpecialReport())
  }

  return (
    <IonRow className='m-5 mt-20'>
      <IonCol size='12'>
        <IonLabel>
          <IonText className='header-title'>{t('specialReports.additionalEmails')}</IonText>
          <IonLabel className='auto-emails-label'>{t('specialReports.additionalEmailsDescription')}</IonLabel>
        </IonLabel>
      </IonCol>
      <IonCol size='12'>
        <hr className='field-divider' />
      </IonCol>
      <IonCol size='12'>
        <AddEmail
          onSave={handleSaveEmail}
          label={t('specialReports.email')}
          buttonLabel={t('specialReports.email')}
          dataTestId='email'
        />
      </IonCol>
      <IonCol size='12'>
        {extraEmail.length > 0 && (
          <IonRow>
            {extraEmail.map((email, index) => (
              <IonCol size='12' key={`extra-email-${index}`} className='ion-no-padding'>
                <IonItem lines='none' className='email-item'>
                  <IonLabel>{email}</IonLabel>
                  <IonIcon
                    icon={closeOutline}
                    size='small'
                    className='email-remove-icon'
                    onClick={() => handleRemoveEmail(email)}
                    data-testid={`remove-email-${index}`}
                  />
                </IonItem>
              </IonCol>
            ))}
          </IonRow>
        )}
      </IonCol>
    </IonRow>
  )
}

const Finish: React.FC = () => {
  return (
    <>
      <AutoEmail />
      <hr className='field-divider' />
      <AdditionalEmail />
    </>
  )
}

export default Finish
